const plugin = (editor) => {

  editor.Components.addType('wf-text-input', {
    isComponent: el => el.classList && el.classList.contains("wf-text-input"),
    model: {
      defaults: {
        tagName: 'input',
        droppable: false,
        highlightable: false,
        attributes: {
          type: 'text',
          class: 'wf-text-input',
        },
        traits: [
          'id',
          'placeholder',
          'variable',
          'question',
          {  type: 'checkbox',  name: 'required'  }
        ],
      },
    }
  });

  editor.DomComponents.addType('wf-submit-button',{
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'wf-submit',
    model: {
      defaults: {
        script: function() {
          console.log('submit button',this);
          new UserTaskSubmitButton({ el: this });
        },
        traits: [
          "classname",
          "bezeichnung",
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      }
    }
  });

  editor.DomComponents.addType('wf-article-input',{
    isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'wf-article-input',
    model: {
      defaults: {
        script: function() {
          console.log('submit button',this);
          new ArticleInputField({ el: this });
        },
        traits: [
          "classname",
          "placeholder"
        ]
      },
      init() {
        this.listenTo(this,"change:attributes",this.handleUpdate);
      },
      handleUpdate() {
        this.view.render();
      }
    }
  });

  editor.Blocks.add('wf-question', {
    label: 'Text-Frage',
    category:'Formulare',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 24 24"><path d="M22 11.9c0-.6-.5-.9-1.3-.9H3.4c-.8 0-1.3.3-1.3.9V17c0 .5.5.9 1.3.9h17.4c.8 0 1.3-.4 1.3-.9V12zM21 17H3v-5h18v5z"/><rect width="14" height="5" x="2" y="5" rx=".5"/><path d="M4 13h1v3H4z"/></svg>',
    content: '<div class="form-group"><label>Ihre Frage hier?</label><input class="form-control wf-text-input" type="text"/></div>'
  });
  editor.Blocks.add('wf-submit-button', {
    id: 'wf-submit-button',
    label: 'Aufgabe übermitteln',
    content: '<div name="wf-submit"></div>',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"/></svg>',
    category: 'Formulare'
  });
  editor.Blocks.add('wf-article-input',{
    id: 'wf-article-input',
    label: 'Artikeleingabe',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 24 24"><path d="M22 11.9c0-.6-.5-.9-1.3-.9H3.4c-.8 0-1.3.3-1.3.9V17c0 .5.5.9 1.3.9h17.4c.8 0 1.3-.4 1.3-.9V12zM21 17H3v-5h18v5z"/><rect width="14" height="5" x="2" y="5" rx=".5"/><path d="M4 13h1v3H4z"/></svg>',
    content: '<div class="form-group"><label>Welchen Artikel möchten Sie?</label><div class="autocomplete" name="wf-article-input"></div></div>',
    category: 'Formulare'
  });

};

export default plugin;
